import { QUESTIONNAIRE_EVALUATION as MODULE_PREFIX } from '../constants';
export const QUESTIONNAIRE_EVALUATION_RESET_QUESTIONNAIRE = `${MODULE_PREFIX}_RESET_QUESTIONNAIRE`;
export const questionnaireEvaluationResetQuestionnaire = () => ({
    type: QUESTIONNAIRE_EVALUATION_RESET_QUESTIONNAIRE,
    payload: null
});
//# sourceMappingURL=questionnaireEvaluationResetAction.js.map